import { isSameDay, format, intervalToDuration } from 'date-fns';
import pluralize from 'pluralize';

export function timeframe(start: Date, end: Date): string {
  const differentDay = !isSameDay(end, start);
  if (differentDay) {
    return `${format(start, 'h:mm aaaa')} – ${format(end, 'h:mm aaaa')} (next day)`;
  }

  const samePeriod = format(start, 'aaaa') === format(end, 'aaaa');
  if (samePeriod) {
    return `${format(start, 'h:mm')} – ${format(end, 'h:mm aaaa')}`;
  }

  return `${format(start, 'h:mm aaaa')} – ${format(end, 'h:mm aaaa')}`;
}

export function duration(start: Date, end: Date): string {
  const d = intervalToDuration({ start, end });
  const pieces: string[] = [];

  if (d.days && d.days > 0) {
    pieces.push(pluralize('day', d.days, true));
  }

  if (d.hours && d.hours > 0) {
    pieces.push(pluralize('hour', d.hours, true));
  }

  if (d.minutes && d.minutes > 0) {
    pieces.push(pluralize('minute', d.minutes, true));
  }

  return pieces.join(', ');
}

export default {
  timeframe,
  duration,
};
